import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { inject, Injectable } from '@angular/core';
import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BriefResultsDto } from '@/app/pages/manage-brief-tabs/tabs/reporting/reporting.helpers';

@Injectable({
  providedIn: 'root',
})
export class UltraSocialService {

  private currentUserService = inject(CurrentUserService);
  private http = inject(HttpClient);

  getUltraSocialCreator(creatorId: string) {
    const get_ultra_social_creator_url = `${environment.shout_api.url}/ultra-social/creator/by-external-id/${creatorId}`;
    return this.http.get<any>(get_ultra_social_creator_url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getSocialAccount(ultra_social_creator_id: string, socialAccountId: string) {
    const get_ultra_social_account_url = `${environment.shout_api.url}/ultra-social/creators/${ultra_social_creator_id}/accounts/${socialAccountId}`;
    return this.http.get<any>(get_ultra_social_account_url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getAccountPosts(ultra_social_creator_id: string, socialAccountId: string) {
    const get_ultra_social_account_posts_url = `${environment.shout_api.url}/ultra-social/creators/${ultra_social_creator_id}/accounts/${socialAccountId}/posts`;
    return this.http.get<any>(get_ultra_social_account_posts_url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }


  /**
   * This creator's follower count per platform, resolved server-side.
   *
   * The API tries the creator record before Ultra Social and writes back anything it
   * learns, so this both answers the question and repairs the stored data. `null` for a
   * platform means unknown — never treat it as zero.
   */
  getCreatorFollowers(externalCreatorId: string) {
    const creator_followers_url = `${environment.shout_api.url}/ultra-social/creator-followers/${externalCreatorId}`;
    return this.http.get<CreatorFollowerCounts>(creator_followers_url, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  /** Results End Points - START */
  /** Every post on a brief with its latest results, read by brief id (piece briefs have no shout brief). */
  getBriefResults(briefId: string) {
    return this.http.get<BriefResultsDto>(`${environment.shout_api.url}/ultra-social/brief-results/${briefId}`);
  }

  getCompleteLatestResultsForPosts(postIds: string[]) {
    const complete_latest_results_for_posts_url = `${environment.shout_api.url}/ultra-social/latest-brief-results`;
    return this.http.post<any>(complete_latest_results_for_posts_url, { postIds }, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
  /** Results End Points - END */
}
export interface UltraSocialCreator {
  id: string;
  displayName: string;
  socialAccounts: UltraSocialSocialAccount[],
  followerCount: number | null;
  joinedAt: string | null;
  externalCreatorId: string;
}

export interface UltraSocialSocialAccount {
  id: string;
  platform: UltraSocialPlatform;
  handle: string;
  displayName: string;
  status: string;
  followerCount: number | null;
}

export type UltraSocialPlatform = "tiktok" | "instagram" | "youtube" | "snapchat";

/** Response of `GET /ultra-social/creator-followers/:externalCreatorId`. */
export interface CreatorFollowerCounts {
  externalCreatorId: string;
  followers: Record<UltraSocialPlatform, number | null>;
}